@if (isProvider) {
  <div class="provider-header">
    <div>
      <img src="../assets/images/logo.png" class="logo" alt="logo" />
    </div>

    <div class="provider-button-container">
      @for (item of headerItems; let i = $index; track i) {
        @switch (item.label) {
          @case ('Messaging') {
            @if (showHeaderButtons()) {
              @if (item.dropdown?.length) {
                @if (unreadMessagesCount) {
                  <div class="provider-notification" matBadge="{{ unreadMessagesCount }}">
                    <div class="hover-container">
                      <img
                        alt="messages"
                        class="provider-notification__logo logo"
                        [attr.aria-label]="item.label"
                        [attr.data-qa]="item.label + '-menu'"
                        [matMenuTriggerFor]="messagingMenu"
                        [matTooltip]="item.tooltip || item.label"
                        [src]="item.icon"
                        tabindex="0" />
                    </div>
                  </div>
                } @else {
                  <div class="provider-notification">
                    <div class="hover-container">
                      <img
                        alt="messages"
                        class="logo logo-button"
                        [attr.aria-label]="item.label"
                        [attr.data-qa]="item.label + '-menu'"
                        [matMenuTriggerFor]="messagingMenu"
                        [matTooltip]="item.tooltip || item.label"
                        [src]="item.icon"
                        tabindex="0" />
                    </div>
                  </div>
                }

                <mat-menu #messagingMenu="matMenu" class="subheader-menu" xPosition="before">
                  @for (menuItem of item.dropdown; let j = $index; track j) {
                    @if (menuItem['route']) {
                      <button
                        class="subheader-menu-item"
                        mat-menu-item
                        [attr.aria-label]="menuItem['label']"
                        [attr.data-qa]="menuItem['label'] + '-submenu'"
                        (click)="navigatePage(menuItem['route'], item.url)"
                        (keyup)="navigatePage(menuItem['route'], item.url)">
                        {{ menuItem['label'] }}
                      </button>
                    } @else {
                      <button
                        class="subheader-menu-item"
                        mat-menu-item
                        [attr.aria-label]="menuItem['label']"
                        [attr.data-qa]="menuItem['label'] + '-submenu'"
                        (click)="cmdSwitch(menuItem['label'])"
                        (keyup)="cmdSwitch(menuItem['label'])">
                        {{ menuItem['label'] }}
                      </button>
                    }
                  }
                </mat-menu>
              } @else {
                @if (unreadMessagesCount) {
                  <div class="provider-notification" matBadge="{{ unreadMessagesCount }}">
                    <div class="hover-container">
                      <img
                        alt="messages"
                        class="provider-notification__logo logo"
                        [attr.aria-label]="item.label"
                        [attr.data-qa]="item.label + '-menu'"
                        [matTooltip]="item.tooltip || item.label"
                        [src]="item.icon"
                        tabindex="0"
                        (click)="navigatePage(item.route, item.url)"
                        (keyup)="navigatePage(item.route, item.url)" />
                    </div>
                  </div>
                } @else {
                  <div class="provider-notification">
                    <div class="hover-container">
                      <img
                        alt="messages"
                        class="logo logo-button"
                        [attr.aria-label]="item.label"
                        [attr.data-qa]="item.label + '-menu'"
                        [matTooltip]="item.tooltip || item.label"
                        [src]="item.icon"
                        tabindex="0"
                        (click)="navigatePage(item.route, item.url)"
                        (keyup)="navigatePage(item.route, item.url)" />
                    </div>
                  </div>
                }
              }
            }
          }
          @case ('Alerts') {
            @if (showHeaderButtons()) {
              @if (notificationCount && showHeaderButtons()) {
                <div #triggers class="provider-notification" matBadge="{{ notificationCount }}">
                  <div class="hover-container">
                    <img
                      #notificationToggle
                      alt="notifications"
                      class="provider-notification__logo logo"
                      [attr.aria-label]="item.label"
                      [attr.data-qa]="item.label + '-menu'"
                      [matTooltip]="item.tooltip || item.label"
                      [src]="item.icon"
                      tabindex="0"
                      (click)="showNotificationCenter()"
                      (keyup)="showNotificationCenter()" />
                  </div>
                </div>
              } @else {
                <div class="provider-notification">
                  <div class="hover-container">
                    <img
                      #notificationToggle
                      alt="notifications"
                      class="logo logo-button"
                      [attr.aria-label]="item.label"
                      [attr.data-qa]="item.label + '-menu'"
                      [matTooltip]="item.tooltip || item.label"
                      [src]="item.icon"
                      tabindex="0"
                      (click)="showNotificationCenter()"
                      (keyup)="showNotificationCenter()" />
                  </div>
                </div>
              }

              @if (showNotification()) {
                <div #notificationOverlay class="notification-center" [style]="{ width: '300px' }">
                  <lib-notification [adminUrl]="adminUrl" (handleHidePanel)="hidePanel()"></lib-notification>
                </div>
              }
            }
          }
          @case ('Profile') {
            @if (item.dropdown) {
              <div class="provider-notification">
                <div class="hover-container">
                  <img
                    alt="profile"
                    class="logo logo-button"
                    [attr.aria-label]="item.label"
                    [attr.data-qa]="item.label + '-menu'"
                    [matMenuTriggerFor]="matMenu"
                    [matTooltip]="item.tooltip || item.label"
                    [src]="item.icon"
                    tabindex="0" />
                </div>
              </div>

              <mat-menu #matMenu="matMenu" class="subheader-menu" xPosition="before">
                @for (menuItem of item.dropdown; let j = $index; track j) {
                  @if (menuItem['route']) {
                    <button
                      class="subheader-menu-item"
                      mat-menu-item
                      [attr.aria-label]="menuItem['label']"
                      [attr.data-qa]="menuItem['label'] + '-submenu'"
                      (click)="navigatePage(menuItem['route'], item.url)"
                      (keyup)="navigatePage(menuItem['route'], item.url)">
                      {{ menuItem['label'] }}
                    </button>
                  } @else {
                    <button
                      class="subheader-menu-item"
                      mat-menu-item
                      [attr.aria-label]="menuItem['label']"
                      [attr.data-qa]="menuItem['label'] + '-submenu'"
                      (click)="cmdSwitch(menuItem['label'])"
                      (keyup)="cmdSwitch(menuItem['label'])">
                      {{ menuItem['label'] }}
                    </button>
                  }
                }
              </mat-menu>
            } @else {
              <div class="provider-notification">
                <div class="hover-container">
                  <img
                    alt="profile"
                    class="logo logo-button"
                    [attr.aria-label]="item.label"
                    [attr.data-qa]="item.label + '-menu'"
                    [matTooltip]="item.tooltip || item.label"
                    [src]="item.icon"
                    tabindex="0"
                    (click)="navigatePage(item.route, item.url)"
                    (keyup)="navigatePage(item.route, item.url)" />
                </div>
              </div>
            }
          }
          @case ('Search') {
            @if (showHeaderButtons()) {
              <!-- Search Button -->
              <div class="provider-notification">
                @if (isAdmin) {
                  <div class="hover-container">
                    <img
                      #searchToggle
                      class="logo logo-button"
                      [alt]="item.label"
                      [attr.aria-label]="item.label"
                      [attr.data-qa]="item.label + '-menu'"
                      [matTooltip]="item.tooltip || item.label"
                      [src]="item.icon"
                      [tabindex]="i"
                      (click)="navigatePage(item.route, item.url, item.label)"
                      (keyup)="navigatePage(item.route, item.url, item.label)" />
                  </div>
                }
                @if (showSearch() && item.label === 'Search') {
                  <!-- Search Panel -->
                  <div #searchPanel class="search-panel">
                    <mat-form-field appearance="outline" class="enrollment-builder-input search-input">
                      <i class="fa fa-search mat-prefix"></i>
                      <input matInput [(ngModel)]="searchValue" (ngModelChange)="onSearch()"
                             [attr.id]="'search-input'" />
                    </mat-form-field>

                    @if (listAllSearch()) {
                      <div class="search-results">
                        <div class="search-results-summary">
                          <p class="summary-title">Search Results</p>
                          <p class="summary-count">
                            {{
                              (listAllSearch()?.provider?.items?.length ?? 0) +
                              (listAllSearch()?.household?.items?.length ?? 0) +
                              (listAllSearch()?.student?.items?.length ?? 0) +
                              (listAllSearch()?.school?.items?.length ?? 0)
                            }}
                            results shown
                          </p>
                        </div>

                        <!-- Providers -->
                        @if ((listAllSearch()?.provider?.items?.length ?? 0) > 0) {
                          <div class="search-section">
                            <div class="section-header">
                              <p class="title">Providers ({{ listAllSearch()?.provider?.items?.length ?? 0 }}
                                results)</p>
                            </div>

                            <mat-list class="section-list">
                              @for (provider of listAllSearch()?.provider?.items ?? []; track provider.id) {
                                <mat-list-item
                                  class="section-item"
                                  (click)="navigateToProviderAccount(provider.id)"
                                  (keyup)="navigateToProviderAccount(provider.id)">
                                  <div class="item-content">
                                    <div class="item-main">
                                      <div class="name">
                                        {{
                                          ((provider.firstName || '') + ' ' + (provider.lastName || '')).trim() ||
                                          provider.businessName
                                        }}
                                      </div>
                                      @if (provider.email || provider.city) {
                                        <div class="meta">
                                          {{ provider.email || '' }}
                                          @if (provider.email && provider.city) {
                                            <span class="meta-separator">•</span>
                                          }
                                          {{ provider.city || '' }}
                                        </div>
                                      }
                                    </div>
                                  </div>
                                </mat-list-item>
                              }

                              @if (listAllSearch()?.provider?.hasMore) {
                                <mat-list-item class="section-item section-load-more-item">
                                  <button type="button" class="load-more-btn" (click)="loadMore('provider')">
                                    Load More Providers
                                  </button>
                                </mat-list-item>
                              }
                            </mat-list>
                          </div>
                        }

                        <!-- Household section -->
                        @if (hasHouseholdSectionResults()) {
                          <div class="search-section">
                            <div class="section-header">
                              <p class="title">Household ({{ householdSectionCount() }} results)</p>
                            </div>

                            @if (householdItems().length > 0) {
                              <mat-list class="section-list">
                                @for (household of householdItems(); track household.id) {
                                  <mat-list-item
                                    class="section-item"
                                    (click)="navigateTo('household', household.id)"
                                    (keyup)="navigateTo('household', household.id)">
                                    <div class="item-content">
                                      <div class="item-main">
                                        <div class="name">{{ household.fullName }}</div>
                                        <div class="meta">Household</div>
                                      </div>
                                    </div>
                                  </mat-list-item>
                                }

                                @if (listAllSearch()?.household?.hasMore) {
                                  <mat-list-item class="section-item section-load-more-item">
                                    <button type="button" class="load-more-btn" (click)="loadMore('household')">
                                      Load More Households
                                    </button>
                                  </mat-list-item>
                                }
                              </mat-list>
                            }

                            @if (studentItems().length > 0) {
                              <mat-list class="section-list">
                                @for (student of studentItems(); track student.id) {
                                  <mat-list-item
                                    class="section-item"
                                    (click)="navigateTo('student', student.id)"
                                    (keyup)="navigateTo('student', student.id)">
                                    <div class="item-content">
                                      <div class="item-main">
                                        <div class="name">{{ student.fullName }}</div>
                                        <div class="meta">Student</div>
                                      </div>
                                    </div>
                                  </mat-list-item>
                                }

                                @if (listAllSearch()?.student?.hasMore) {
                                  <mat-list-item class="section-item section-load-more-item">
                                    <button type="button" class="load-more-btn" (click)="loadMore('student')">
                                      Load More Students
                                    </button>
                                  </mat-list-item>
                                }
                              </mat-list>
                            }
                          </div>
                        }

                        <!-- Schools -->
                        @if ((listAllSearch()?.school?.items?.length ?? 0) > 0) {
                          <div class="search-section">
                            <div class="section-header">
                              <p class="title">Schools ({{ listAllSearch()?.school?.items?.length ?? 0 }} results)</p>
                            </div>

                            <mat-list class="section-list">
                              @for (school of schoolItems(); track school.id) {
                                <mat-list-item
                                  class="section-item"
                                  (click)="navigateTo('school', school.id)"
                                  (keyup)="navigateTo('school', school.id)">
                                  <div class="item-content">
                                    <div class="item-main">
                                      <div class="name">{{ school.name }}</div>
                                      <div class="meta">School</div>
                                    </div>
                                  </div>
                                </mat-list-item>
                              }

                              @if (listAllSearch()?.school?.hasMore) {
                                <mat-list-item class="section-item section-load-more-item">
                                  <button type="button" class="load-more-btn" (click)="loadMore('school')">
                                    Load More Schools
                                  </button>
                                </mat-list-item>
                              }
                            </mat-list>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            }
          }
          @default {
            <!-- Generic Button (FAQ, etc.) -->
            @if (item.badge) {
              <div #triggers class="provider-notification" matBadge="{{ item.badge }}">
                <div class="hover-container">
                  <img
                    alt="{{ item.label }}"
                    class="provider-notification__logo logo"
                    [attr.aria-label]="item.label"
                    [attr.data-qa]="item.label + '-menu'"
                    [matTooltip]="item.tooltip || item.label"
                    [src]="item.icon"
                    tabindex="0"
                    (click)="navigatePage(item.route, item.url)"
                    (keyup)="navigatePage(item.route, item.url)" />
                </div>
              </div>
            } @else if ((item.dropdown?.length ?? 0) > 1) {
              <div class="provider-notification">
                <div class="hover-container">
                  <img
                    class="logo logo-button"
                    [alt]="item.label"
                    [attr.aria-label]="item.label"
                    [attr.data-qa]="item.label + '-menu'"
                    [matTooltip]="item.label"
                    [src]="item.icon"
                    tabindex="0"
                    [matMenuTriggerFor]="faqMenu" />
                </div>
              </div>
              <mat-menu #faqMenu="matMenu" class="subheader-menu" xPosition="before">
                @for (menuItem of item.dropdown; track $index) {
                  <button
                    class="subheader-menu-item"
                    mat-menu-item
                    [attr.aria-label]="menuItem['label']"
                    [attr.data-qa]="menuItem['label'] + '-submenu'"
                    (click)="navigatePage(menuItem['route'], item.url, item.label)"
                    (keyup)="navigatePage(menuItem['route'], item.url, item.label)">
                    {{ menuItem['label'] }}
                  </button>
                }
              </mat-menu>
            } @else {
              <div class="provider-notification">
                <div class="hover-container">
                  <img
                    class="logo logo-button"
                    [alt]="item.label"
                    [attr.aria-label]="item.label"
                    [attr.data-qa]="item.label + '-menu'"
                    [matTooltip]="item.tooltip || item.label"
                    [src]="item.icon"
                    tabindex="0"
                    (click)="navigatePage(item.route, item.url, item.label)"
                    (keyup)="navigatePage(item.route, item.url, item.label)" />
                </div>
              </div>
            }
          }
        }
      }
    </div>

    <button
      aria-label="Header Items"
      class="provider-menu-button"
      data-qa="provider-menu-button"
      mat-icon-button
      [matMenuTriggerFor]="menu">
      <img alt="menu" [src]="menuIcon" />
    </button>
  </div>

  <mat-menu #menu="matMenu" class="header-menu">
    @for (item of headerItems; let i = $index; track i) {
      <button class="header-menu-item" mat-menu-item>
        <div class="header-menu-item-container">
          <img
            alt="menuitem"
            [attr.aria-label]="item.label"
            [attr.data-qa]="item.label + '-menu'"
            [matTooltip]="item.tooltip || item.label"
            [src]="item.icon" />
          <span>{{ item.label }}</span>
        </div>
      </button>
    }
  </mat-menu>
} @else {
  <div class="header">
    <div class="logo-header">
      <img alt="NCSEAA Logo" class="logo" height="85" width="323" ngSrc="../assets/images/logo.png" />
    </div>

    <div class="login-header">
      @if (isLoggedIn) {
        <button
          class="user-menu mat-icon-button"
          data-qa="user-menu-button"
          disableRipple="true"
          mat-button
          aria-label="User menu"
          [matMenuTriggerFor]="menu">
          <i class="fa-regular fa-user"></i>
        </button>

        <mat-menu #menu="matMenu" class="user-mat-menu" data-qa="user-mat-menu">
          @for (item of userMenu; track $index) {
            <button data-qa="logout-button" disableRipple="true" mat-menu-item (click)="userLogout()">
              <span>{{ item.label }}</span>
            </button>
          }
        </mat-menu>
      } @else {
        <button
          class="primary_materials_button xlarge_button"
          data-qa="login-button"
          disableRipple="true"
          mat-stroked-button
          (click)="isLoggedIn = !isLoggedIn">
          Login
        </button>
      }

      <button
        class="primary_materials_button xlarge_button"
        data-qa="entra-logout-button"
        disableRipple="true"
        mat-stroked-button
        (click)="logoutEntra()">
        Entra Logout
      </button>
    </div>
  </div>

  @if (isAdmin) {
    <div class="admin-menu">
      <button
        class="menu mat-icon-button"
        data-qa="admin-menu-button"
        disableRipple="true"
        mat-button
        [matMenuTriggerFor]="menu">
        <i class="fa fa-bars" aria-hidden="true"></i>
        <span class="sr-only">Admin Menu</span>
      </button>

      <mat-menu #menu="matMenu" class="admin-mat-menu">
        @for (item of topMenu; track $index) {
          <button disableRipple="true" mat-menu-item>
            <span>{{ item.label }}</span>
          </button>
        }
      </mat-menu>
    </div>
  }
}
